// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import MuseUI from 'muse-ui';
import 'muse-ui/dist/muse-ui.css';
import $ from 'jquery';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Paginate from 'vuejs-paginate'
Vue.component('paginate', Paginate)

//import VueMouseParallax from 'vue-mouse-parallax'
 
window.$ = $;
const VueScrollTo = require('vue-scrollto')
//Vue.use(VueMouseParallax)
Vue.use(VueAxios, axios)
Vue.use(VueScrollTo)
Vue.use(MuseUI);
Vue.config.productionTip = false


/* eslint-disable no-new */
new Vue({
    el: '#app',
    created () {
      AOS.init({
        once:true,
      })
    },
    router,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js